import {Injectable} from '@angular/core';
import {HttpService} from '../../shared/services/http/http.service';
import {RestService} from '../../shared/services/http/rest.service';
import {ConfigService} from '../shared/services/config.service';
import {environment} from '../../environments/environment';
import {SizerType} from '../models/generic.model';
import { OpportunityQueryParam } from '../models/general-models';

export enum OppTypes {
  active = 'active',
  starred = 'starred',
  favorite = 'favorite',
  archive = 'archive'
}

@Injectable()
export class OpportunityService extends RestService {
    url = environment.http.baseUrl;
    // baseUrl = environment.http.baseUrl + '/opportunity';
    queryName = 'OPPORTUNITY';
    ajaxLoaderEnabled = true;
    opportunityList = [];
    pageData = {
        pages: 0,
        pageNum: 10,
        searchStr: '',
        tabSelected: 'active',
        selectAllFlag: true,
        advanceSearchFields: {
            'id': [],
            'name': [],
            'version': [],
            'customer_name': [],
            'created_by': [],
            'sfdc_id': [],
            'last_modified_by': []
        },
        sortInfo: {
            isDesc: false,
            direction: 0,
            column: ''
        }
    };

    private oppApiQuery : OpportunityQueryParam | null = null;
    private oppType : OppTypes = OppTypes.active;

    constructor(httpService: HttpService, private configService: ConfigService) {
        super(httpService);
    }

    resizeOpprtunity(payload) {
        this.baseUrl =  '/opportunity/' + payload.id + '/resize';
        delete payload['resizeOption'];
        delete payload['adminFlag'];
        return this.save('', '', payload);
    }

    addOpportunity(payload) {
        this.baseUrl =  '/opportunity/';
        delete payload['resizeOption'];
        delete payload['adminFlag'];
        payload['action'] = 'add-opportunity';
        return this.save('', '', payload);
    }

    importWorkloadJson(payload) {
        this.baseUrl = (environment.enableHeterogeneousClusters === true) ?  '/opportunity/v2/import-json' :  '/opportunity/import-json';
        delete payload['resizeOption'];
        delete payload['adminFlag'];
        return this.save('', '', payload);
    }

    editOpportunity(payload) {
        this.baseUrl =  '/opportunity';
        delete payload['resizeOption'];
        delete payload['adminFlag'];
        return this.update({ id: payload.id }, '', payload);
    }

    cloneOpportunity(payload) {
        this.baseUrl =  '/opportunity/clone';
        delete payload['resizeOption'];
        delete payload['adminFlag'];
        return this.save({ id: payload.id }, '', payload);
    }

    getOpportunityList(loaderId, sizerType?: SizerType, query:OpportunityQueryParam=null) {
        this.baseUrl = '/opportunity/?';
        if (sizerType === SizerType.Commercial) {
          this.baseUrl += `&commercial=true`;
        }
        return this.query('', query, loaderId);
    }

    getSingleOpportunity(id:number) {
        this.baseUrl =  '/opportunity/' + id;
        return this.query('', '', 'SINGLE_OPP_LOADING');
    }

    getalloppList(){
        this.baseUrl = '/opportunity/';
        return this.query('','','');
    }
    getArchiveList(isSimpleSizer=false) {
        this.baseUrl =  `/opportunity/?archive=true${isSimpleSizer?'&commercial=true':''}`;
        return this.query();
    }

    getOpportunityById(id) {
        this.baseUrl =  '/opportunity/' + id;
        return this.query();
    }

    deleteOpportunity(id) {
        this.baseUrl =  '/opportunity';
        return this.delete({ id: id });
    }

    changeOppoDataPatch(payload) {
        this.baseUrl =  '/opportunity/';
        return this.patch('', '', payload);
    }

    getResiliencyList() {
        this.baseUrl = '/envsetup/resiliency';
        return this.query();
    }

    getLocationList() {
        this.baseUrl = '/envsetup/location';
        return this.query();
    }

    getPrePolicyList() {
        this.baseUrl =  '/envsetup/prepolicy';
        return this.query();
    }

    getNodePrefList() {
        this.baseUrl =  '/envsetup/nodes';
        return this.query();
    }

    getUseCaseTypeList() {
        this.baseUrl = '/envsetup/workloads';
        return this.query();
    }

    setPrePolicyListData(policyList) {
        this.configService.setPrepolicyListData(policyList);
    }

    setResiliencyList(resList) {
        this.configService.setResiliencyList(resList);
    }

    setLocationList(locList) {
        this.configService.setLocationList(locList);
    }

    setNodePrefList(nodeList) {
        this.configService.setNodePrefListData(nodeList);
    }

    setUseCaseTypeListData(useCase) {
        this.configService.setUseCaseTypeListData(useCase);
    }

    setOpportunityData(opportunity) {
        this.configService.setOpportunityData(opportunity);
    }

    setOpportunityList(oppoList) {
        this.configService.setOpportunityList(oppoList);
    }

    setOppoPageInfo(pageData) {
        this.pageData = pageData;
    }

    getOppoPageInfo() {
        return this.pageData;
    }

    getOppoList() {
        return this.configService.getOpportunityList();
    }

    fetchVersion() {
        return this.configService.fetchVersion();
    }

    fetchUserDetails() {
        return this.configService.fetchUserDetails();
    }
    getPrePolicyListData() {
        return this.configService.getPrepolicyListData();
    }
    addNodeConfiguration(nodeSetDetails) {
        this.baseUrl = '/opportunity/' + nodeSetDetails.opp_id + '/nodeconfig/';
        return this.save('', '', nodeSetDetails);
    }
    getNodeConfiguration(oppurtunity_id) {
        this.baseUrl = '/opportunity/' + oppurtunity_id + '/nodeconfig/'
        return this.query();
    }
    getResiliencyListData() {
        return this.configService.getResiliencyListData();
    }
    getLocationListData() {
        return this.configService.getLocationListData();
    }
    setOppApiQuery( query: OpportunityQueryParam) {
        this.oppApiQuery = { ...query };
    }
    getOppApiQuery() {
        return this.oppApiQuery
    }
    setOppType(oppType: OppTypes) {
        this.oppType = oppType;
    }
    getOppType() {
        return this.oppType
    }

}
